import { Component } from '@angular/core';
import { AccordionComponent } from '@shared/components/accordion/accordion.component';
import { ProductTabComponent } from '@b2b/components/product/product-tab/product-tab.component';

@Component({
  selector: 'product-description',
  imports: [AccordionComponent],
  templateUrl: './product-description.component.html',
})
export class ProductDescriptionComponent extends ProductTabComponent {}
